"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireDefault(require("react"));

var _propTypes = babelHelpers.interopRequireDefault(require("prop-types"));

// @babel: { "presets": [ "es2015", "react" ], "plugins": [ "transform-flow-strip-types", "transform-decorators-legacy", "transform-class-properties", "transform-object-rest-spread" ]}
var Elements =
/*#__PURE__*/
function (_React$Component) {
  babelHelpers.inherits(Elements, _React$Component);

  function Elements(props, context) {
    var _this;

    babelHelpers.classCallCheck(this, Elements);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Elements).call(this, props, context));

    _this.handleRegisterElement = function (type, element) {
      _this.setState(function (prevState) {
        return {
          registeredElements: [].concat(babelHelpers.toConsumableArray(prevState.registeredElements), [{
            type: type,
            element: element
          }])
        };
      });
    };

    _this.handleUnregisterElement = function (el) {
      _this.setState(function (prevState) {
        return {
          registeredElements: prevState.registeredElements.filter(function (_ref) {
            var element = _ref.element;
            return element !== el;
          })
        };
      });
    };

    var _this$props = _this.props,
        children = _this$props.children,
        options = babelHelpers.objectWithoutProperties(_this$props, ["children"]);
    _this._elements = _this.context.stripe.elements(options);
    _this.state = {
      registeredElements: []
    };
    return _this;
  }

  babelHelpers.createClass(Elements, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this2 = this;

      return {
        elements: this._elements,
        registerElement: this.handleRegisterElement,
        unregisterElement: this.handleUnregisterElement,
        getRegisteredElements: function getRegisteredElements() {
          return _this2.state.registeredElements;
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.Children.only(this.props.children);
    }
  }]);
  return Elements;
}(_react.default.Component);

exports.default = Elements;
Elements.childContextTypes = {
  elements: _propTypes.default.object.isRequired,
  registerElement: _propTypes.default.func.isRequired,
  unregisterElement: _propTypes.default.func.isRequired,
  getRegisteredElements: _propTypes.default.func.isRequired
};
Elements.contextTypes = {
  stripe: _propTypes.default.object.isRequired
};
Elements.defaultProps = {
  children: null
};